import { first,  filter, map, takeUntil, flatMap } from 'rxjs/operators';
import { RoutingHistoryService } from './../services/routingHistory.service';
import { Component, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd, Data } from "@angular/router";
import { Subject } from "rxjs";
import { StreamService } from "../services";
import * as _ from 'lodash';

@Component({
    styles: [`
        .big-icon {
            font-size: 20px
        }
    `],
    template: `
        <nav mat-tab-nav-bar *ngIf="!hideNavbar">
            <ng-container *ngFor="let link of navLinks">
                <a mat-tab-link
                   *ngIf="showLink(link)"
                   [routerLink]="link.path"
                   routerLinkActive #rla="routerLinkActive"
                   [active]="rla.isActive">{{link.label}}</a>
            </ng-container>
        </nav>
        <router-outlet></router-outlet>
    `
})
export class EditTopicComponent implements OnDestroy {
    private cleanupTime = new Subject<void>();
    topic: any;
    navLinks = [
        { path: ['./', 'content'], label: 'Content', showFor: 'all'},
        { path: ['./', 'aggregation'], label: 'Aggregation', showFor: 'source', hideType: 'PRODUCT_SOURCE' },
        { path: ['./', 'topics'], label: 'Topics', showFor: 'source' },
        { path: ['./', 'people'], label: 'People', showFor: 'topic' },
        { path: ['./', 'groups'], label: 'Groups', showFor: 'topic' },
        { path: ['./', 'settings'], label: 'Settings', showFor: 'all' },
    ];
    hideNavbar: boolean;
    isSource: boolean;
    isCatalog: boolean;

    constructor(private route: ActivatedRoute, 
                private router: Router, 
                private routingHistoryService: RoutingHistoryService, 
                streamService: StreamService) {

        route.data.pipe(takeUntil(this.cleanupTime)).subscribe((data: Data) => {
            this.isSource = data.isSource;
            this.isCatalog = data.isCatalog; 
        });

        router.events.pipe(
            takeUntil(this.cleanupTime),
            filter(event => event instanceof NavigationEnd),
            map(() => route.firstChild && route.firstChild.snapshot && route.firstChild.snapshot.data && route.firstChild.snapshot.data.noNavBar)
        )
        .subscribe(hideIt => this.hideNavbar = hideIt)

        route.params.pipe(
            takeUntil(this.cleanupTime),
            filter(params => this.isNewTopic(params.topicId)),
            flatMap(params => streamService.getStream(params.topicId).pipe(first()))
        )
        .subscribe(stream => this.topic = stream);
    }

    showLink(link): boolean {
        const extraHide = this.topic && link.hideType && this.topic.type === link.hideType;
        return (this.isSource && !extraHide && ['all', 'source'].indexOf(link.showFor) !== -1) ||
               (!this.isSource && ['all', 'topic'].indexOf(link.showFor) !== -1 && (!['People', 'Groups'].includes(link.label) || !this.isCatalog));
    }

    isNewTopic = (topicId) => topicId && (!this.topic || this.topic.id !== topicId);

    back():void {
        if (this.route.firstChild && 
            this.route.firstChild.snapshot.url.length === 1 && 
            this.route.firstChild.snapshot.url[0].path === 'invite') {
            this.router.navigateByUrl(this.routingHistoryService.getPreviousUrl());
        } else {
            const reverseHistory = _.reverse(this.routingHistoryService.getHistory());
            if (reverseHistory[0].includes('/topics/')) {
                this.router.navigateByUrl(_.find(reverseHistory, url => !url.startsWith('/topics/') && !url.startsWith('/login'), 1) || '');
            } else {
                this.router.navigate(['/digest', 'recent']);
            }
        }
    } 

    ngOnDestroy(): void {
        this.cleanupTime.next();
    }
}
